import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import * as Highcharts from 'src/assets/js/highcharts';

declare const ApexCharts: any;


@Component({
  selector: 'g10-app-installation-report',
  templateUrl: './app-installation-report.component.html',
  styleUrls: ['./app-installation-report.component.css']
})
export class AppInstallationReportComponent implements OnInit {

  public chartData: any = {
    emp: [],
    driver: [],
    average: [],
  }
  constructor(public api: ApiService) { }

  ngOnInit(): void {
    this.getAPIdata();
  }

  getLastMonths(n) {

    let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    let today = new Date();
    let lastMonths = []

    for (let i = 0; i < n; i++) {
      let monthKey = today.getMonth() - i;
      let newDate = new Date(today.getTime());
      newDate.setMonth(monthKey);
      let monthStTs = new Date(newDate.getFullYear(), monthKey).getTime();
      let monthEndTs = new Date(newDate.getFullYear(), (monthKey + 1), 0, 23, 59, 59).getTime();
      lastMonths.push({
        name: monthNames[newDate.getMonth()] + ' - ' + newDate.getFullYear(),
        month: newDate.getMonth()+1,
        year: newDate.getFullYear(),
        startTs: monthStTs,
        endTs: monthEndTs,
      });
    }
    return lastMonths;
  }


  async getAPIdata() {
    let todayTs = new Date().getTime();
    let monthVal = new Date().getMonth();
    let startDateTs = new Date(new Date().setMonth(monthVal - 5)).getTime();
    let obj = {
      startDate: startDateTs,
      endDate: todayTs,
    };
    await this.getEmpAppExlReport(obj);
    await this.getDriverAppExlReport(obj);
    this.processChart();
  }

  async getEmpAppExlReport(obj) {
    this.chartData['emp'] = [];
    let results: any = await this.api.transportManagerEmpAppExlReports(obj).catch((e) => {
      console.log('Data retriving issues')
    });

    if (results && results['status'] == 'success') {
      if (results['data'].length > 0) {
        this.chartData.emp = results['data'];
      }
    }

  }

  async getDriverAppExlReport(obj) {
    this.chartData['driver'] = [];

    let results: any = await this.api.transportManagerDriverAppExlReports(obj).catch((err) => { console.log(err) })

    if (results && results['status'] == 'success') {
      if (results['data'].length > 0) {
        this.chartData.driver = results['data'];
      }
    }
  }


  processChart() {
    let data = {
      column: {
        emp: {
          value: [],

        },
        driver: {
          value: [],
        },
        average: {
          value: [],
        },
        xCategory: [],
      },
      pie: {
        total: 0,
        emp: 0,
        driver: 0,
      },
      spline: {
        emp: {
          value: [],
          xCategory: [],
        },
        driver: {
          value: [],
          xCategory: [],
        }
      }
    };

    data.pie.emp = this.chartData.emp.length;
    data.pie.driver = this.chartData.driver.length;
    data.pie.total = this.chartData.emp.length + this.chartData.driver.length;

    let months = this.getLastMonths(5);
    for (let m = 0; m < months.length; m++) {
      let obj = months[m];

      let empMonthVal = 0;
      let driverMonthVal = 0;
      let inbetweenDays = Math.ceil((obj.endTs - obj.startTs) / (1000 * 60 * 60 * 24));
      for (let d = 0; d < inbetweenDays; d++) {
        let currentDay = new Date().getTime();
        let currentStartTs = new Date(new Date(obj.startTs).setDate(d + 1)).getTime();
        let currentEndTs = new Date(new Date(new Date(obj.startTs).setDate(d + 1)).setHours(23, 59, 59)).getTime();
        let currentDayEmp = 0;
        let currentDayDriver = 0;
        if(currentStartTs<currentDay){
          this.chartData.emp.map((item) => {
            if ((obj.startTs < item['lastLoginTime']) && (obj.endTs >= item['lastLoginTime'])) {
              if ((currentStartTs < item['lastLoginTime']) && (currentEndTs >= item['lastLoginTime'])) {
                currentDayEmp++;
                empMonthVal++;
              }
            }
          })
          this.chartData.driver.map((item) => {
            if ((obj.startTs < item['lastLoginTime']) && (obj.endTs >= item['lastLoginTime'])) {
              if ((currentStartTs < item['lastLoginTime']) && (currentEndTs >= item['lastLoginTime'])) {
                currentDayDriver++;
                driverMonthVal++;
              }
            }
          })
          if (m == 0) {
            // let xCategoryDate = new Date(currentStartTs).getDate() + ' ' + obj['name'];
            data.spline.emp.value.unshift({ x: currentStartTs, y: currentDayEmp });
            // data.spline.emp.xCategory.unshift(xCategoryDate);
            data.spline.driver.value.unshift({ x: currentStartTs, y: currentDayDriver });
            // data.spline.driver.xCategory.unshift(xCategoryDate);
          }
        }
      }

      data.column.emp.value.unshift(empMonthVal);
      data.column.driver.value.unshift(driverMonthVal);
      data.column.average.value.unshift(Math.floor((empMonthVal + driverMonthVal) / 2));
      data.column.xCategory = [obj['name'], ...data.column.xCategory];

    }
    // console.log(monthVal);
    this.loadChart(data);
    this.loadEmpChart(data);
    this.loadDriverChart(data);
  }

  groupmonth(value, tsKey) {
    let bymonth = {};
    let d: any = new Date(value[tsKey]);
    d = (d.getFullYear() - 1970) * 12 + d.getMonth();
    bymonth[d] = bymonth[d] || [];
    bymonth[d].push(value);
    return bymonth
  }



  loadChart(data: any) {
    const chartOptions = {
      title: {
        text: 'App Usage chart'
      },
      xAxis: {
        categories: data.column.xCategory
      },
      yAxis:{
        title:{
          text: 'Usage Count'
        }
      },
      labels: {
        items: [{
          html: 'Total App Usage',
          style: {
            left: '40px',
            top: '0px',
            color: ( // theme 
              Highcharts.defaultOptions.title.style &&
              Highcharts.defaultOptions.title.style.color
            ) || 'black'
          }
        }]
      },
      series: [{
        type: 'column',
        name: 'Driver App',
        data: data.column.driver.value,
        color: "#6462af"

      }, {
        type: 'column',
        name: 'Employee App',
        data: data.column.emp.value,
        color: "#4c7dfe"
      }/*  ,{
        type: 'spline',
        name: 'Average',
        data: data.column.average.value,
        color: '#64E572',//
        marker: {
          lineWidth: 2,
          lineColor: Highcharts.getOptions().colors[3],
          fillColor: 'white'
        }, */, {
        type: 'pie',
        name: 'Total App Usage',
        data: [{
          name: 'Employee App',
          y: data.pie.emp,
          color: "#4c7dfe"
        }, {
          name: 'Driver App',
          y: data.pie.driver,
          color: '#6462af'//Highcharts.getOptions().colors[0]
        }],
        center: [70, 30],
        size: 60,
        showInLegend: false,
        dataLabels: {
          enabled: false
        }
      }]
    };

    const reportDashboard = Highcharts.chart('reportDashboard', chartOptions);
  }
  loadEmpChart(data: any) {
    Highcharts.chart('empReportDashboard', {
      chart: {
        type: 'spline',
    },
    title: {
      text: 'Employee App Usage',
    },
    legend: {
      enabled: false
    },
    xAxis: {
        type: 'datetime',
        labels: {
            overflow: 'justify'
        }
    },
    yAxis: {
        title: {
            text: 'Usage count'
        },
    },
    plotOptions: {
        spline: {
            lineWidth: 4,
            states: {
                hover: {
                    lineWidth: 5
                }
            },
            marker: {
                enabled: false
            },
        },
        series: {
          color: "#4c7dfe"
      }
    },
    series:  [{
      name: '',
      data: data.spline.emp.value

    }],
    navigation: {
        menuItemStyle: {
            fontSize: '10px'
        }
    },
      tooltip: {
        shared: true,
        useHTML: true,
        formatter: function () {
          let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
          ];
          return 'Employee App Usage At <br><b>' + new Date(this.x).getDate() + ' ' + monthNames[new Date(this.x).getMonth()] + ' ' + new Date(this.x).getFullYear() +
            '</b> is <b>' + this.y + '</b>';
        },
        split:true,
      },     
    });
  }
  loadDriverChart(data: any) {
    Highcharts.chart('driverReportDashboard', {
      chart: {
        type: 'spline',
    },
    title: {
      text: 'Driver App Usage',
    },
    legend: {
      enabled: false
    },
    xAxis: {
        type: 'datetime',
        labels: {
            overflow: 'justify'
        }
    },
    yAxis: {
        title: {
            text: 'Usage count'
        },
    },
    plotOptions: {
        spline: {
            lineWidth: 4,
            states: {
                hover: {
                    lineWidth: 5
                }
            },
            marker: {
                enabled: false
            },
        },
        series: {
          color: "#6462af"
      }
    },
    series:  [{
      name: '',
      data: data.spline.driver.value

    }],
    navigation: {
        menuItemStyle: {
            fontSize: '10px'
        }
    },
      tooltip: {
        shared: true,
        useHTML: true,
        formatter: function () {
          let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
          ];
          return 'Driver App Usage At <br><b>' + new Date(this.x).getDate() + ' ' + monthNames[new Date(this.x).getMonth()] + ' ' + new Date(this.x).getFullYear() +
            '</b> is <b>' + this.y + '</b>';
        },
        split:true,
      },     
    });
  }

}
